module.exports = __webpack_public_path__ + "img/i-notif-mono.87b8335e.svg";